export const heent = (() => {
    const placeHolderText = 'No glaucoma or major changes to vision.  No congestion or bleeding.  No pharyngeal or hearing complains.'

    return placeHolderText
})